var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "view-panel" },
    [
      !_vm.pluginShow && _vm.properties.length === 0
        ? _c("div", { staticClass: "no-properties" }, [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("chart.chart_no_properties")) + "\n  "
            ),
          ])
        : _vm._e(),
      _vm.pluginShow
        ? _c("plugin-com", {
            staticClass: "attr-style theme-border-class",
            staticStyle: {
              overflow: "auto",
              "border-right": "1px solid #e6e6e6",
              height: "100%",
              width: "100%",
            },
            attrs: {
              "component-name": _vm.view.type + "-style",
              obj: {
                view: _vm.view,
                param: _vm.param,
                chart: _vm.chart,
                dimensionData: _vm.dimensionData,
                quotaData: _vm.quotaData,
              },
            },
          })
        : _vm._e(),
      !_vm.pluginShow && _vm.properties.length > 0
        ? _c(
            "div",
            {
              staticClass: "attr-style theme-border-class",
              staticStyle: {
                overflow: "auto",
                "border-right": "1px solid #e6e6e6",
                height: "100%",
                width: "100%",
                "padding-right": "6px",
              },
            },
            [
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showPropertiesCollapse([
                        "color-selector",
                        "size-selector",
                        "size-selector-ant-v",
                        "label-selector",
                        "label-selector-ant-v",
                        "tooltip-selector",
                        "tooltip-selector-ant-v",
                        "total-cfg",
                        "suspension-selector",
                      ]),
                      expression:
                        "showPropertiesCollapse([\n        'color-selector', 'size-selector', 'size-selector-ant-v',\n        'label-selector', 'label-selector-ant-v',\n        'tooltip-selector', 'tooltip-selector-ant-v',\n        'total-cfg', 'suspension-selector'])",
                    },
                  ],
                  staticClass: "de-collapse-style",
                },
                [
                  _c("span", { staticClass: "padding-lr" }, [
                    _vm._v(_vm._s(_vm.$t("chart.shape_attr"))),
                  ]),
                  _c(
                    "el-collapse",
                    {
                      staticClass: "style-collapse",
                      model: {
                        value: _vm.attrActiveNames,
                        callback: function ($$v) {
                          _vm.attrActiveNames = $$v
                        },
                        expression: "attrActiveNames",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "color-selector",
                              ]),
                              expression:
                                "showPropertiesCollapse(['color-selector'])",
                            },
                          ],
                          attrs: {
                            name: "color",
                            title: _vm.$t("chart.color"),
                          },
                        },
                        [
                          _c("color-selector", {
                            staticClass: "attr-selector",
                            attrs: {
                              param: _vm.param,
                              chart: _vm.chart,
                              "property-inner":
                                _vm.propertyInnerAll["color-selector"],
                            },
                            on: {
                              onColorChange: function ($event) {
                                return _vm.onColorChange(
                                  $event,
                                  "color-selector"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "size-selector",
                              ]),
                              expression:
                                "showPropertiesCollapse(['size-selector'])",
                            },
                          ],
                          attrs: {
                            name: "size",
                            title:
                              _vm.chart.type && _vm.chart.type.includes("table")
                                ? _vm.$t("chart.table_config")
                                : _vm.$t("chart.size"),
                          },
                        },
                        [
                          _c("size-selector", {
                            staticClass: "attr-selector",
                            attrs: {
                              param: _vm.param,
                              "property-inner":
                                _vm.propertyInnerAll["size-selector"],
                              chart: _vm.chart,
                            },
                            on: {
                              onSizeChange: function ($event) {
                                return _vm.onSizeChange($event, "size-selector")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "size-selector-ant-v",
                              ]),
                              expression:
                                "showPropertiesCollapse(['size-selector-ant-v'])",
                            },
                          ],
                          attrs: {
                            name: "size",
                            title:
                              _vm.chart.type && _vm.chart.type.includes("table")
                                ? _vm.$t("chart.table_config")
                                : _vm.$t("chart.size"),
                          },
                        },
                        [
                          _c("size-selector-ant-v", {
                            staticClass: "attr-selector",
                            attrs: {
                              param: _vm.param,
                              chart: _vm.chart,
                              "property-inner":
                                _vm.propertyInnerAll["size-selector-ant-v"],
                              "quota-fields": _vm.quotaData,
                            },
                            on: {
                              onSizeChange: function ($event) {
                                return _vm.onSizeChange(
                                  $event,
                                  "size-selector-ant-v"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "label-selector",
                                "label-selector-ant-v",
                              ]),
                              expression:
                                "showPropertiesCollapse(['label-selector', 'label-selector-ant-v'])",
                            },
                          ],
                          attrs: {
                            name: "label",
                            title: _vm.$t("chart.label"),
                          },
                        },
                        [
                          _vm.showProperties("label-selector")
                            ? _c("label-selector", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll["label-selector"],
                                },
                                on: {
                                  onLabelChange: function ($event) {
                                    return _vm.onLabelChange(
                                      $event,
                                      "label-selector"
                                    )
                                  },
                                },
                              })
                            : _vm.showProperties("label-selector-ant-v")
                            ? _c("label-selector-ant-v", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll[
                                      "label-selector-ant-v"
                                    ],
                                },
                                on: {
                                  onLabelChange: function ($event) {
                                    return _vm.onLabelChange(
                                      $event,
                                      "label-selector-ant-v"
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "tooltip-selector",
                                "tooltip-selector-ant-v",
                              ]),
                              expression:
                                "showPropertiesCollapse(['tooltip-selector', 'tooltip-selector-ant-v'])",
                            },
                          ],
                          attrs: {
                            name: "tooltip",
                            title: _vm.$t("chart.tooltip"),
                          },
                        },
                        [
                          _vm.showProperties("tooltip-selector")
                            ? _c("tooltip-selector", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll["tooltip-selector"],
                                },
                                on: {
                                  onTooltipChange: function ($event) {
                                    return _vm.onTooltipChange(
                                      $event,
                                      "tooltip-selector"
                                    )
                                  },
                                },
                              })
                            : _vm.showProperties("tooltip-selector-ant-v")
                            ? _c("tooltip-selector-ant-v", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll[
                                      "tooltip-selector-ant-v"
                                    ],
                                },
                                on: {
                                  onTooltipChange: function ($event) {
                                    return _vm.onTooltipChange(
                                      $event,
                                      "tooltip-selector-ant-v"
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse(["total-cfg"]),
                              expression:
                                "showPropertiesCollapse(['total-cfg'])",
                            },
                          ],
                          attrs: {
                            name: "totalCfg",
                            title: _vm.$t("chart.total_cfg"),
                          },
                        },
                        [
                          _c("total-cfg", {
                            staticClass: "attr-selector",
                            attrs: {
                              param: _vm.param,
                              chart: _vm.chart,
                              "property-inner":
                                _vm.propertyInnerAll["total-cfg"],
                            },
                            on: {
                              onTotalCfgChange: function ($event) {
                                return _vm.onTotalCfgChange($event, "total-cfg")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "suspension-selector",
                              ]),
                              expression:
                                "showPropertiesCollapse(['suspension-selector'])",
                            },
                          ],
                          attrs: {
                            name: "suspension",
                            title: _vm.$t("chart.suspension"),
                          },
                        },
                        [
                          _c("suspension-selector", {
                            staticClass: "attr-selector",
                            attrs: {
                              param: _vm.param,
                              chart: _vm.chart,
                              "property-inner":
                                _vm.propertyInnerAll["suspension-selector"],
                            },
                            on: {
                              onSuspensionChange: function ($event) {
                                return _vm.onSuspensionChange(
                                  $event,
                                  "suspension-selector"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "de-collapse-style" },
                [
                  _c("span", { staticClass: "padding-lr" }, [
                    _vm._v(_vm._s(_vm.$t("chart.module_style"))),
                  ]),
                  _c(
                    "el-collapse",
                    {
                      staticClass: "style-collapse",
                      model: {
                        value: _vm.styleActiveNames,
                        callback: function ($$v) {
                          _vm.styleActiveNames = $$v
                        },
                        expression: "styleActiveNames",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "x-axis-selector",
                                "x-axis-selector-ant-v",
                              ]),
                              expression:
                                "showPropertiesCollapse(['x-axis-selector', 'x-axis-selector-ant-v'])",
                            },
                          ],
                          attrs: {
                            name: "xAxis",
                            title: _vm.$t("chart.xAxis"),
                          },
                        },
                        [
                          _vm.showProperties("x-axis-selector")
                            ? _c("x-axis-selector", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll["x-axis-selector"],
                                },
                                on: {
                                  onChangeXAxisForm: function ($event) {
                                    return _vm.onChangeXAxisForm(
                                      $event,
                                      "x-axis-selector"
                                    )
                                  },
                                },
                              })
                            : _vm.showProperties("x-axis-selector-ant-v")
                            ? _c("x-axis-selector-ant-v", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll[
                                      "x-axis-selector-ant-v"
                                    ],
                                },
                                on: {
                                  onChangeXAxisForm: function ($event) {
                                    return _vm.onChangeXAxisForm(
                                      $event,
                                      "x-axis-selector-ant-v"
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "y-axis-selector",
                                "y-axis-selector-ant-v",
                              ]),
                              expression:
                                "showPropertiesCollapse(['y-axis-selector', 'y-axis-selector-ant-v'])",
                            },
                          ],
                          attrs: {
                            name: "yAxis",
                            title:
                              _vm.view.type === "chart-mix"
                                ? _vm.$t("chart.yAxis_main")
                                : _vm.$t("chart.yAxis"),
                          },
                        },
                        [
                          _vm.showProperties("y-axis-selector")
                            ? _c("y-axis-selector", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll["y-axis-selector"],
                                },
                                on: {
                                  onChangeYAxisForm: function ($event) {
                                    return _vm.onChangeYAxisForm(
                                      $event,
                                      "y-axis-selector"
                                    )
                                  },
                                },
                              })
                            : _vm.showProperties("y-axis-selector-ant-v")
                            ? _c("y-axis-selector-ant-v", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll[
                                      "y-axis-selector-ant-v"
                                    ],
                                },
                                on: {
                                  onChangeYAxisForm: function ($event) {
                                    return _vm.onChangeYAxisForm(
                                      $event,
                                      "y-axis-selector-ant-v"
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "y-axis-ext-selector",
                                "y-axis-ext-selector-ant-v",
                              ]),
                              expression:
                                "showPropertiesCollapse(['y-axis-ext-selector', 'y-axis-ext-selector-ant-v'])",
                            },
                          ],
                          attrs: {
                            name: "yAxisExt",
                            title: _vm.$t("chart.yAxis_ext"),
                          },
                        },
                        [
                          _vm.showProperties("y-axis-ext-selector")
                            ? _c("y-axis-ext-selector", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll["y-axis-ext-selector"],
                                },
                                on: {
                                  onChangeYAxisForm: function ($event) {
                                    return _vm.onChangeYAxisExtForm(
                                      $event,
                                      "y-axis-ext-selector"
                                    )
                                  },
                                },
                              })
                            : _vm.showProperties("y-axis-ext-selector-ant-v")
                            ? _c("y-axis-ext-selector-ant-v", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll[
                                      "y-axis-ext-selector-ant-v"
                                    ],
                                },
                                on: {
                                  onChangeYAxisForm: function ($event) {
                                    return _vm.onChangeYAxisExtForm(
                                      $event,
                                      "y-axis-ext-selector-ant-v"
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "split-selector",
                                "split-selector-ant-v",
                              ]),
                              expression:
                                "showPropertiesCollapse(['split-selector', 'split-selector-ant-v'])",
                            },
                          ],
                          attrs: {
                            name: "split",
                            title: _vm.$t("chart.split"),
                          },
                        },
                        [
                          _vm.showProperties("split-selector")
                            ? _c("split-selector", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll["split-selector"],
                                },
                                on: {
                                  onChangeSplitForm: function ($event) {
                                    return _vm.onChangeSplitForm(
                                      $event,
                                      "split-selector"
                                    )
                                  },
                                },
                              })
                            : _vm.showProperties("split-selector-ant-v")
                            ? _c("split-selector-ant-v", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll[
                                      "split-selector-ant-v"
                                    ],
                                },
                                on: {
                                  onChangeSplitForm: function ($event) {
                                    return _vm.onChangeSplitForm(
                                      $event,
                                      "split-selector-ant-v"
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "title-selector",
                                "title-selector-ant-v",
                              ]),
                              expression:
                                "showPropertiesCollapse(['title-selector', 'title-selector-ant-v'])",
                            },
                          ],
                          attrs: {
                            name: "title",
                            title: _vm.$t("chart.title"),
                          },
                        },
                        [
                          _vm.showProperties("title-selector")
                            ? _c("title-selector", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll["title-selector"],
                                },
                                on: {
                                  onTextChange: function ($event) {
                                    return _vm.onTextChange(
                                      $event,
                                      "title-selector"
                                    )
                                  },
                                },
                              })
                            : _vm.showProperties("title-selector-ant-v")
                            ? _c("title-selector-ant-v", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll[
                                      "title-selector-ant-v"
                                    ],
                                },
                                on: {
                                  onTextChange: function ($event) {
                                    return _vm.onTextChange(
                                      $event,
                                      "title-selector-ant-v"
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "legend-selector",
                                "legend-selector-ant-v",
                              ]),
                              expression:
                                "showPropertiesCollapse(['legend-selector', 'legend-selector-ant-v'])",
                            },
                          ],
                          attrs: {
                            name: "legend",
                            title: _vm.$t("chart.legend"),
                          },
                        },
                        [
                          _vm.showProperties("legend-selector")
                            ? _c("legend-selector", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll["legend-selector"],
                                },
                                on: {
                                  onLegendChange: function ($event) {
                                    return _vm.onLegendChange(
                                      $event,
                                      "legend-selector"
                                    )
                                  },
                                },
                              })
                            : _vm.showProperties("legend-selector-ant-v")
                            ? _c("legend-selector-ant-v", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll[
                                      "legend-selector-ant-v"
                                    ],
                                },
                                on: {
                                  onLegendChange: function ($event) {
                                    return _vm.onLegendChange(
                                      $event,
                                      "legend-selector-ant-v"
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.view.customStyle && _vm.view.customStyle.background
                        ? _c(
                            "el-collapse-item",
                            {
                              attrs: {
                                name: "background",
                                title: _vm.$t("chart.background"),
                              },
                            },
                            [
                              _c("background-color-selector", {
                                staticClass: "attr-selector",
                                attrs: { param: _vm.param, chart: _vm.chart },
                                on: {
                                  onChangeBackgroundForm: function ($event) {
                                    return _vm.onChangeBackgroundForm(
                                      $event,
                                      "background-color-selector"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPropertiesCollapse([
                                "margin-selector",
                              ]),
                              expression:
                                "showPropertiesCollapse(['margin-selector'])",
                            },
                          ],
                          attrs: {
                            name: "margin",
                            title: _vm.$t("panel.margin"),
                          },
                        },
                        [
                          _vm.showProperties("margin-selector")
                            ? _c("margin-selector", {
                                staticClass: "attr-selector",
                                attrs: {
                                  param: _vm.param,
                                  chart: _vm.chart,
                                  "property-inner":
                                    _vm.propertyInnerAll["margin-selector"],
                                },
                                on: {
                                  onMarginChange: function ($event) {
                                    return _vm.onMarginChange(
                                      $event,
                                      "margin-selector"
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showPropertiesCollapse([
                          "condition-style-selector",
                        ]) && _vm.markSelectorShow,
                      expression:
                        "showPropertiesCollapse(['condition-style-selector']) && markSelectorShow",
                    },
                  ],
                  staticClass: "de-collapse-style",
                },
                [
                  _c("span", { staticClass: "padding-lr" }, [
                    _vm._v(_vm._s(_vm.$t("chart.function_style"))),
                  ]),
                  _c(
                    "el-collapse",
                    {
                      staticClass: "style-collapse",
                      model: {
                        value: _vm.styleActiveNames,
                        callback: function ($$v) {
                          _vm.styleActiveNames = $$v
                        },
                        expression: "styleActiveNames",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.showPropertiesCollapse([
                                  "condition-style-selector",
                                ]) && _vm.markSelectorShow,
                              expression:
                                "showPropertiesCollapse(['condition-style-selector']) && markSelectorShow",
                            },
                          ],
                          attrs: {
                            name: "conditionStyle",
                            title: _vm.$t("chart.condition_style"),
                          },
                        },
                        [
                          _c("map-mark-selector", {
                            staticClass: "attr-selector",
                            attrs: {
                              param: _vm.param,
                              chart: _vm.chart,
                              view: _vm.view,
                              "dimension-data": _vm.dimensionData,
                              "quota-data": _vm.quotaData,
                            },
                            on: { onMarkChange: _vm.onMarkChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }